import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { AiOutlineClose } from "react-icons/ai";
import "styles/base-modals.scss";

const PolicyAndTerms = ({ src, title }: { src: string; title: string }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const toggleModel = () => {
    setIsOpen((oldState) => !oldState);
  };
  return (
    <>
      <span onClick={toggleModel} className="modal-span" style={{ fontSize: 14 }}>
        {title}
      </span>
      <Modal toggle={toggleModel} isOpen={isOpen} fullscreen={true}>
        <ModalHeader
          close={
            <AiOutlineClose
              onClick={toggleModel}
              className="modal-header-close-icon"
            />
          }
          className="modal-header"
        />
        <ModalBody className="modal-body">
          <iframe
            className="modal-iframe"
            src={src}
            frameBorder="0"
            title={title}
          ></iframe>
        </ModalBody>
        <ModalFooter>
          <Button onClick={toggleModel}>Cancel</Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default PolicyAndTerms;
